import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 引入仓库
import user from './user'

export default new Vuex.Store({
    modules:{
      // user
    },
    mutations: {
      // 设置用户信息
      setUser(state, userData) {
        state.user = userData;
      },
    },
})